import React, { useEffect, useRef, useState } from 'react';
import { View, Text, FlatList, TouchableOpacity, ScrollView, Animated, Easing, Alert, } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import HeaderWithBack from '../../components/Header/headerWithBack';
import { calculateTimeDifference, generateToken, getCleanUrl } from '../../utils/Helper';
import { ImageComp } from '../../components/Image/Image';
import CustomPressable from '../../components/customPressable/customPressable';
import { fetchStoreInfo, getStoreInfo, placeHcomOrder } from '../../Redux/Actions/hcommerceAction';
import { StoreLevel1 } from './storeLevel1';
import { StoreLevel2 } from './storeLevel2';
import MyOrders from './myOrders';
import { setCurrentWidget } from '../../Redux/Reducers/deviceConfigReducer';
import ItemInfo from './itemInfo';
import ItemAddOnsPopup from './updateItemAddOnsPopup';
import { getDataLoadingScreen } from '../../js/getDataLoadingScreen';
import { useTranslation } from 'react-i18next';
import { useCssStyle } from '../../customHook/getCssStyle';
import { setGoHome, setShowLoginModal } from '../../Redux/Reducers/appConfigReducer';
import CustomFlatList from '../../components/customFlatList';
import InfoPopupModal from '../../components/infoPopupModal';
import { CHEVRON_RIGHT } from '../../assets';
import FetchingDataScreen from '../../components/fetchingDataScreen';
import { sendAnalytics } from '../../Redux/Actions/analyticsAction';
import { CLICKED, EXIT, HCOMMERCE, INITIAL_LOADER_SCREEN, STORE1, STORE2 } from '../../config/Constant';

const HCommerce = ({ navigation }) => {

  const dispatch = useDispatch();

  const { t } = useTranslation();
  const getStyles = useCssStyle();

  const hasTriggeredGoHome = useRef(false);



  const { isLoggedIn } = useSelector(state => state.appConfigSlice);
  const { currentWidget } = useSelector(state => state.deviceConfigSlice);
  const { currencyDetails } = useSelector(state => state.deviceConfigSlice);
  const { hcommerceStoreSkuData } = useSelector(state => state.storeInfoSlice);

  let widgetLaunchTime = new Date;
  const storeName = currentWidget?.displayName; 
  const [hcommerceSessionToken, setHCommerceSessionToken] = useState(() => generateToken("hcommerce_"));



  const [initialLoading, setInitialLoading] = useState(false);
  
  const [loaderState, setLoaderState] = useState({
    showLoader: false,
    loaderMessage: ""
  });

  const toggleLoaderState = (state, message) => {
    setLoaderState({
      showLoader: state,
      loaderMessage: state ? message : ""
    })
  }


  const [errorState, setErrorState] = useState({
    isError: false,
    errorMessage: ""
  })

  const toggleErrorState = (state, message) => {
    setErrorState({
      isError: state,
      errorMessage: state ? message : ""
    })
  }




  const [currentPage, setCurrentPage] = useState("StoreLevel1");

  const [storeSku, setStoreSku] = useState(currentWidget?.storeSku || null);
  const [storeData, setStoreData] = useState({});

  const [selectedStoreItemSubType, setSelectedStoreItemSubType] = useState({});
  const [cartItem, setCartItem] = useState([]);
  const [cartItemQuantity, setCartitemQuanitity] = useState([]);
  const [cartItemPrice, setCartItemPrice] = useState(0);

  const [selectedStoreItem, setSelectedStoreItem] = useState({});
  const [showItemInfo, setShowItemInfo] = useState(false);
  const [showAddOnsPopup, setShowAddOnsPopup] = useState(false);

  const [showAttentionPopup, setShowAttentionPopup] = useState(false);


  const currencyCode = currencyDetails.code;

  const sortStoreData = (data) => {

    let updatedStoreData = { ...data };

    // sorting data for storeItemSubTypeInfo;
    updatedStoreData.storeItemSubTypeInfo = updatedStoreData.storeItemSubTypeInfo.map((storeItemSubTypeInfo) => {

      let storeItemSubTypeID = [];
      let storeItemID = [];

      updatedStoreData.subTypeSubTypeMapping.forEach((subTypeSubTypeMappingInfo) => {
        if (storeItemSubTypeInfo.id == subTypeSubTypeMappingInfo.storeItemSubTypeParentId) {
          storeItemSubTypeID.push(subTypeSubTypeMappingInfo.storeItemSubTypeChildId)
        }
      })

      updatedStoreData.storeItemStoreItemSubTypeInfo.forEach((storeItemStoreItemSubTypeMappingInfo) => {
        if (storeItemSubTypeInfo.id == storeItemStoreItemSubTypeMappingInfo.storeItemSubType.id) {
          storeItemID.push(storeItemStoreItemSubTypeMappingInfo.storeItem.id);
        }
      })

      return {
        ...storeItemSubTypeInfo,
        storeItemSubTypeID,
        storeItemID
      };
    })


    // sorting data for storeItemTypeInfo;
    updatedStoreData.storeItemTypeInfo = updatedStoreData.storeItemTypeInfo.map((storeItemTypeInfo) => {

      let storeItemSubTypeID = [];
      let storeItemID = [];

      updatedStoreData.storeItemTypeSubTypeInfo.forEach((storeItemTypeSubTypeMappingInfo) => {
        if (storeItemTypeInfo.id == storeItemTypeSubTypeMappingInfo.storeItemType.id) {
          storeItemSubTypeID.push(storeItemTypeSubTypeMappingInfo.storeItemSubType.id)
        }
      })

      updatedStoreData.storeItemStoreItemTypeInfo.forEach((storeItemStoreItemTypeMappingInfo) => {
        if (storeItemTypeInfo.id == storeItemStoreItemTypeMappingInfo.storeItemType.id) {
          storeItemID.push(storeItemStoreItemTypeMappingInfo.storeItem.id);
        }
      })

      return {
        ...storeItemTypeInfo,
        storeItemSubTypeID,
        storeItemID
      };
    })

    // sorting data for storeItemInfo;
    updatedStoreData.storeItemInfo = updatedStoreData.storeItemInfo.map((storeItemInfo) => {

      let upsellItemID = [];
      updatedStoreData.storeItemStoreUpsellItemInfo.forEach((storeItemStoreUpsellItemMappingInfo) => {
        if (storeItemInfo.id == storeItemStoreUpsellItemMappingInfo.storeItem.id) {
          upsellItemID.push(storeItemStoreUpsellItemMappingInfo.storeUpsellItem.id)
        }
      })

      let hasItemAddOns = updatedStoreData.itemAddOnsInfo.some(
        (itemAddOnsMappingInfo) => storeItemInfo.id === itemAddOnsMappingInfo.storeItemId
      );


      return {
        ...storeItemInfo,
        hasItemAddOns,
        upsellItemID
      };
    })


    setStoreData(updatedStoreData);
  }

  useEffect(() => {

    if (storeSku && hcommerceStoreSkuData[storeSku]?.storeData) {
      if(!hcommerceStoreSkuData[storeSku].storeData.storeInfo.allowDayGuestOrdering && !isLoggedIn){
        if(!hasTriggeredGoHome.current){
          hasTriggeredGoHome.current = true;
          dispatch(setGoHome(true));
          dispatch(setShowLoginModal(true))
          return;
        }
      }

      sortStoreData(hcommerceStoreSkuData[storeSku].storeData);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storeSku, hcommerceStoreSkuData])


  const fetchStoreInfoFunc = async () => {


    const isDataAlreadyThere = !!hcommerceStoreSkuData[storeSku]?.storeData;


    !isDataAlreadyThere && setInitialLoading(true);


    const fetchStoreInfoResponse = await dispatch(fetchStoreInfo(storeSku));

    setInitialLoading(false);
    dispatch(sendAnalytics(HCOMMERCE, fetchStoreInfoResponse.status == "SUCCESS" ? "STORE INFO FETCH - SUCCESS" : "STORE INFO FETCH - FAILED", { storeName: storeName, element: "widget", storeSku: currentWidget.storeSku, widgetSessionId: hcommerceSessionToken }))
    
    if (!(fetchStoreInfoResponse.status == "SUCCESS") && !isDataAlreadyThere) {
      toggleErrorState(true, fetchStoreInfoResponse.message)
    }
  }

  useEffect(() => {
    if (storeSku) {
      fetchStoreInfoFunc();
      dispatch(sendAnalytics(HCOMMERCE, CLICKED, { storeName: storeName, element: "widget", storeSku: currentWidget.storeSku, widgetSessionId: hcommerceSessionToken }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storeSku])

  useEffect(() => {
    if (currentWidget.storeSku) {
      setStoreSku(currentWidget.storeSku);
    }
  }, [currentWidget])

  useEffect(() => {

    return () => {
      if(storeSku){
        const widgetCloseTime = new Date;
        const widgetCloseDuration = calculateTimeDifference(widgetLaunchTime, widgetCloseTime, 'second');
        dispatch(sendAnalytics(HCOMMERCE, EXIT, { storeName: storeName, element: "widget", duration: widgetCloseDuration, widgetSessionId: hcommerceSessionToken }))
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])



  // handle cart 

  const handleAddToCart = (itemInfo, selectedAddOns = [], proceedWithSelectedAddOns = false) => {

    let updatedCartItem = [...cartItem];

    // Check if the item has add-ons and Stop further execution until the user selects add-ons
    if (itemInfo.hasItemAddOns) {

      if (!proceedWithSelectedAddOns) {
        setSelectedStoreItem(itemInfo);
        setShowAddOnsPopup(true);
        return;
      }
    }

    const sortedSelectedAddOns = selectedAddOns.slice().sort((a, b) => a.id - b.id);

    // Check if the item with the same addOns already exists in the cart
    const existingItemIndex = updatedCartItem.findIndex(item => {
      const sortedItemAddOns = item.addOns.slice().sort((a, b) => a.id - b.id);
      return item.itemInfo.id === itemInfo.id &&
        sortedItemAddOns.length === sortedSelectedAddOns.length &&
        sortedItemAddOns.every((addOn, index) => addOn.id === sortedSelectedAddOns[index].id); // Compare ids
    });


    if (existingItemIndex !== -1) {

      updatedCartItem[existingItemIndex] = {
        ...updatedCartItem[existingItemIndex],
        quantity: updatedCartItem[existingItemIndex].quantity + (itemInfo.quantity || 1),
        totalPrice: updatedCartItem[existingItemIndex].totalPrice + (itemInfo.itemPrice * (itemInfo.quantity || 1)),
      };
    } else {

      const updatedItemInfo = {
        itemInfo,
        quantity: itemInfo.quantity || 1,
        addOns: selectedAddOns,
        totalPrice: (itemInfo.itemPrice * (itemInfo.quantity || 1)) + selectedAddOns.reduce((sum, addOn) => sum + addOn.price, 0),
      };
      updatedCartItem.push(updatedItemInfo);
    }

    setCartItem(updatedCartItem);
  }

  const handleRemoveFromCart = (itemInfo = {}, itemIndex = null) => {
    let updatedCartItem = [...cartItem];

    // Find all items with the matching itemId
    const matchingItems = updatedCartItem.filter(item => item.itemInfo.id === itemInfo.id);

    if (matchingItems.length > 1 && itemIndex === null) {
      // If there are multiple items with the same itemId and no index is provided, show the popup
      setSelectedStoreItem(itemInfo);
      setShowAddOnsPopup(true);
      return;
    }

    // If an itemIndex is provided, use it; otherwise, find the first matching item
    const targetIndex = itemIndex !== null ? itemIndex : updatedCartItem.findIndex(item => item.itemInfo.id === itemInfo.id);

    if (targetIndex !== -1) {
      const existingItem = updatedCartItem[targetIndex];

      if (existingItem.quantity > 1) {
        // Reduce the quantity and adjust the total price
        updatedCartItem[targetIndex] = {
          ...existingItem,
          quantity: existingItem.quantity - 1,
          totalPrice: existingItem.totalPrice - existingItem.itemInfo.itemPrice,
        };
      } else {
        updatedCartItem.splice(targetIndex, 1);
      }
    }

    setCartItem(updatedCartItem);
  };


  useEffect(() => {

    console.log("items in cart: ", cartItem)

    let cartItemQuantity = cartItem.reduce((totalQuantity, item) => totalQuantity + +item.quantity, 0);
    setCartitemQuanitity(cartItemQuantity);


    let cartItemPrice = cartItem.reduce((totalPrice, item) => totalPrice + +item.totalPrice, 0);
    setCartItemPrice(cartItemPrice)
  }, [cartItem])






  // handle my orders page
  const handleMyOrders = () => {
    setCurrentPage("MyOrders");
  }

  const handlePlaceOrder = async (payload) => {

    toggleLoaderState(true, "Placing order...");

    const orderResponse = await dispatch(placeHcomOrder(storeSku, payload));

    toggleLoaderState(false, "");
    dispatch(sendAnalytics(HCOMMERCE, orderResponse.status == "SUCCESS" ? "PLACE ORDER - SUCCESS" : "PLACE ORDER - FAILED", { storeName: storeName, element: "widget", storeSku: currentWidget.storeSku, widgetSessionId: hcommerceSessionToken }))

    if(orderResponse.status == "SUCCESS"){
      setCartItem([]);
      handleGoBack();
    }
  }




  // handle addons popup
  const handleCloseAddOnsPopup = () => {
    setShowAddOnsPopup(false);
    handleCloseItemsInfo();
  }



  // handle Item info page state

  const handleItemInfo = (itemInfo) => {
    setSelectedStoreItem(itemInfo);
    setShowItemInfo(true);
  }


  const handleCloseItemsInfo = () => {
    setSelectedStoreItem({});
    setShowItemInfo(false);
  }



  // handle store level 2
  const handleStoreItemSubTypeSelect = (storeItemSubType) => {
    setSelectedStoreItemSubType(storeItemSubType);
    setCurrentPage("StoreLevel2");
  }



  // handle go back

  const handleClosePopup = () => {
    setShowAttentionPopup(false);
  };

  const handleGoBack = (forceGoHome = false) => {

    if (forceGoHome) {
      dispatch(setGoHome(true));
      return;
    }

    if (showAddOnsPopup) {
      setShowAddOnsPopup(false);
      return;
    }

    if (showItemInfo) {
      handleCloseItemsInfo();
      return;
    }

    if (currentPage != "StoreLevel1") {
      setCurrentPage("StoreLevel1");
      return;
    }
    if (cartItemQuantity > 0) {
      setShowAttentionPopup(true);
      return;
    }

    dispatch(setGoHome(true));
  }

  const getCurrentPage = () => {
    switch (currentPage) {
      case "StoreLevel1":
        return (
          <StoreLevel1
            storeData={storeData}
            handleStoreItemSubTypeSelect={handleStoreItemSubTypeSelect}
            cartItem={cartItem}
            handleItemInfo={handleItemInfo}
            handleAddToCart={handleAddToCart}
            handleRemoveFromCart={handleRemoveFromCart}
            storeName={storeName}
            hcommerceSessionToken={hcommerceSessionToken}
          />
        )
      case "StoreLevel2":
        return (
          <StoreLevel2
            storeData={storeData}
            selectedStoreItemSubType={selectedStoreItemSubType}
            handleStoreItemSubTypeSelect={handleStoreItemSubTypeSelect}
            cartItem={cartItem}
            handleItemInfo={handleItemInfo}
            handleAddToCart={handleAddToCart}
            handleRemoveFromCart={handleRemoveFromCart}
            storeName={storeName}
            hcommerceSessionToken={hcommerceSessionToken}
          />
        )
      case "MyOrders":
        return (
          <MyOrders
            storeData={storeData}
            storeInfo={storeData.storeInfo}
            cartItem={cartItem}
            handlePlaceOrder={handlePlaceOrder}
            handleAddToCart={handleAddToCart}
            handleRemoveFromCart={handleRemoveFromCart}
            handleGoBack={handleGoBack}
            storeName={storeName}
            hcommerceSessionToken={hcommerceSessionToken}
            currentWidget={currentWidget}
          />
        )
    }
  }

  let scaleAnimation = useRef(new Animated.Value(1)).current;

  // Trigger animation when cartItemQuantity updates on My order btn
  useEffect(() => {

    Animated.sequence([
      Animated.timing(scaleAnimation, {
        toValue: 1.5, // Increase size
        duration: 200,
        easing: Easing.ease,
        useNativeDriver: true,
      }),
      Animated.timing(scaleAnimation, {
        toValue: 1, // Return to original size
        duration: 200,
        easing: Easing.ease,
        useNativeDriver: true,
      })
    ]).start();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartItemQuantity]);


  return (
    <View style={getStyles(['widgetRootContainer', 'hcommerceRootContainer'])}>
      <HeaderWithBack handleCustomBackPress={handleGoBack} />


      {!storeSku ?


        <View style={getStyles(['widgetmainContainer', 'hcommerceMainContainer'])}>

          <View style={getStyles(['widgetmainContainerHeaderContainer', 'hcommerceHeaderContainer'])}>
            {
              currentWidget?.widgetHeaderImageUrl &&
              <ImageComp source={getCleanUrl(currentWidget?.widgetHeaderImageUrl)} style={getStyles(['widgetmainContainerHeaderImg', 'hcommerceHeaderImg'])} />
            }
            <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'hcommerceHeaderTitleContainer'])}>
              <Text style={getStyles(['widgetmainContainerHeaderTitle', 'hcommerceHeaderTitle'])}>{t('h-commerce.select_store')}</Text>
            </View>
          </View>

          <View style={getStyles(['widgetmainContainerChildContainer', 'hcommerceMainContainerChildContainer'])}>

            {Object.values(hcommerceStoreSkuData).map((widgetData) => {
              return (
                <CustomPressable key={widgetData.id} style={getStyles(['list_itemContainer', 'hcommerce_itemContainer'])} onPress={() => dispatch(setCurrentWidget(widgetData))}>

                  {widgetData?.widgetHeaderImageUrl && <ImageComp
                    source={getCleanUrl(widgetData?.widgetHeaderImageUrl)}
                    style={getStyles(['list_itemContainer_image', 'hcommerce_itemContainer_image'])}
                  />}

                  <View style={getStyles(['list_itemContainer_textContainer', 'hcommerce_itemContainer_textContainer'])}>
                    {widgetData?.widgetTitle && <Text style={getStyles(['list_itemContainer_textContainer_title', 'hcommerce_itemContainer_textContainer_title'])}>{widgetData.displayName}</Text>}
                  </View>

                  <View style={getStyles(['list_itemContainer_arrow', 'hcommerce_itemContainer_arrow'])}>
                    <ImageComp source={CHEVRON_RIGHT} />
                  </View>
                </CustomPressable>

              );
            })}

          </View>

        </View>
        :
        getCurrentPage()
      }


      {showItemInfo &&
        <ItemInfo
          selectedStoreItem={selectedStoreItem}
          handleCloseItemsInfo={handleCloseItemsInfo}
          handleAddToCart={handleAddToCart}
          handleRemoveFromCart={handleRemoveFromCart}
        />
      }

      {showAddOnsPopup && (
        <ItemAddOnsPopup
          itemAddOnsInfo={storeData.itemAddOnsInfo || []}
          cartItem={cartItem}
          handleAddToCart={handleAddToCart}
          handleRemoveFromCart={handleRemoveFromCart}
          selectedStoreItem={selectedStoreItem}
          handleCloseAddOnsPopup={handleCloseAddOnsPopup}
        />
      )}

      {cartItem.length > 0 && currentPage != "MyOrders" && !showItemInfo &&
        <View style={getStyles(['footer_button_container', 'myOrder_container'])} id='footer_button_container myOrder_container'>
          <View style={getStyles(['myOrder_container_price_container'])} id='myOrder_container_price_container'>
            <Text style={getStyles(['myOrder_container_price_container_text'])} id='myOrder_container_price_container_text'>Total</Text>
            <Text style={getStyles(['myOrder_container_price_container_text'])} id='myOrder_container_price_container_text'>{currencyCode + cartItemPrice}</Text>
          </View>

          <CustomPressable style={getStyles(['primaryBtn'])} onPress={handleMyOrders} id="primaryBtn">
            <Text style={getStyles(['primaryBtnTxt'])} id='primaryBtnTxt'>
              {t('h-commerce.my_order')} {' '}
            </Text>
            <Animated.View style={[getStyles(['myOrder_container_count_container']), { transform: [{ scale: scaleAnimation }] }]} id={"myOrder_container_count_container"}>
              <Text style={getStyles(['myOrder_container_count_container_text'])} id='myOrder_container_count_container_text'>{cartItemQuantity}</Text>
            </Animated.View>
          </CustomPressable>
        </View>
      }

      {showAttentionPopup &&
        <InfoPopupModal
          title={"Attention!"}
          subtitle={t('h-commerce.items_inCart_info')}
          onClose={handleClosePopup}
          secondaryBtnLabel={"No"}
          onContinue={() => handleGoBack(true)}
          primaryBtnLabel={"Yes"}
        />
      }

      {errorState.errorMessage &&
        <InfoPopupModal
          subtitle={errorState.errorMessage}
          onClose={() => {toggleErrorState(false); handleGoBack();}}
          secondaryBtnLabel={"Back"}
          onContinue={() => {toggleErrorState(false); fetchStoreInfoFunc()}}
          primaryBtnLabel={"Try again"}
        />
      }


      {loaderState.showLoader && <FetchingDataScreen loaderMessage={loaderState.loaderMessage} />}
      {initialLoading && getDataLoadingScreen(INITIAL_LOADER_SCREEN)}

    </View>
  )
};

export default HCommerce;
